import React, { Component } from 'react';
import config, { currentCountryCode } from '../../../config';
import ResponsiveBanner from '../../Common/ResponsiveBanner';
import SupportEmail from '../../Common/Helpers/SupportEmail';
import ContactInfo from './ContactInfo';
import { withContactInfoData } from './WithContactInfoData';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';

export const renderIfMY = (WrappedComponent) => {
  if (currentCountryCode === 'MY') {
    return props => <WrappedComponent {...props}/>;
  }
  return () => null;
};

export const renderIfNotMY = (WrappedComponent) => {
  if (currentCountryCode !== 'MY') {
    return props => <WrappedComponent {...props}/>;
  }
  return () => null;
};

class EmailInfoSection extends Component {
  render() {
    const {
      contactInfo = [],
      code = currentCountryCode.toLowerCase(),
    } = this.props;
    return (
      <div className='mb-6 my-5'>
        <div className='text-gray-lighten-1 bg-gray-lighten-4 p-4'>
          <ContactInfo data={contactInfo} code={code}/>
        </div>
      </div>
    );
  }
}

export const EmailInfo = renderIfNotMY(withContactInfoData(EmailInfoSection));

const EmailInfoWithMapMY = (props) => {
  const {
    t
  } = props;
  return (
    <div className='bg-gray-lighten-4 py-7'>
      <div className='page-wrapper row mx-auto'>
        <div className='col-12 col-lg-5 mb-4'>
          <h2><HTMLTrans id="contact_us.view_title">Looking for us?</HTMLTrans></h2>
          <div><HTMLTrans id="contact_us.view_description">Our Global HQ is located at:</HTMLTrans></div>
          <br/>
          <address>
            <div>
            <HTMLTrans id="contact_us.view_map">
              <span className='ProximaNova-Bold'>
                Photobook Worldwide HQ
                <a href='https://goo.gl/maps/RggCE2dWUkC2' target="_blank"> (MAP)</a>
              </span><br/>
              7, Jalan TP 2, Sime UEP Industrial Park,<br/>
              47600 Subang Jaya, Selangor, Malaysia<br/>
            </HTMLTrans>
            </div>
            <div className='d-flex mt-3'>
              <div className='mr-3'><i className="fa fa-phone"></i></div>
              <div><HTMLTrans id="contact_us.view_phone">Not Available</HTMLTrans></div>
            </div>
            <div className='d-flex mt-3'>
              <div className='mr-3'><i className="fa fa-clock-o"></i></div>
              <div><HTMLTrans id="contact_us.view_working_hours">Monday – Friday: 9am - 6pm<br/>Saturdays: 9am - 1pm</HTMLTrans></div>
            </div>
            <div className='d-flex mt-3'>
              <div className='mr-3'><i className="fa fa-envelope-o"></i></div>
              <div><SupportEmail/></div>
            </div>
            <div className='d-flex mt-3'>
              <div className='mr-3'><i className="fa fa-whatsapp" style={{ color: '#25d366' }}></i></div>
              <div>
                <a href={t('contact_us.view_whatsapp_link', 'https://wa.me/60126485909?text=Hi')} target="_blank">
                  <HTMLTrans id="contact_us.view_whatsapp_link_text">Chat with us on WhatsApp Web</HTMLTrans>
                </a>
              </div>
            </div>
          </address>
        </div>
      </div>
    </div>
  );
};

export const EmailInfoWithMap = renderIfMY(withTranslationProvider(EmailInfoWithMapMY));

export const Banner = props => (
  <div className='card border-0'>
    <ResponsiveBanner
      desktop={`${config.s3BucketUrl}/banners/banner-contactus_desktop_fallback.jpg`}
      tablet={`${config.s3BucketUrl}/banners/banner-contactus_tablet.jpg`}
      mobile={`${config.s3BucketUrl}/banners/banner-contactus_mobile@2x.jpg`}
    />
    <div className='d-flex flex-column card-img-overlay justify-content-center container'>
      <h1 className="card-text text-gray d-none d-md-block"><HTMLTrans id="contact_us.view_banner_title">Contact Us</HTMLTrans></h1>
    </div>
    <h1 className='card-text text-gray bg-gray-lighten-4 p-4 d-md-none'><HTMLTrans id="contact_us.view_banner_title">Contact Us</HTMLTrans></h1>
  </div>
);



// WEBPACK FOOTER //
// ./src/StaticPage/ContactUs/ViewComponents.js